import { ITab } from '../../_models/tabsInterface'

export const headerTabs: ITab[] = [
  {
    id: 1,
    label: 'features',
    path: '/features',
  },
  {
    id: 2,
    label: 'blog',
    path: '/coming-soon',
  },
  {
    id: 3,
    label: 'contact',
    path: '/contact-us',
  },
]
